import { useState } from "react";
import { fieldNames } from "../../components/Identification/steps/step3/utils";

const {
  IDENTIFICATION_NUMBER,
  LEGAL_FORM,
  NAME_OF_COMPANY,
  TEXT_AREA
} = fieldNames;

const initState = {
  [LEGAL_FORM]: "",
  [IDENTIFICATION_NUMBER]: "",
  [NAME_OF_COMPANY]: "",
  [TEXT_AREA]:"",
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
